import React, { useState } from "react";
import Styles from "./index.module.scss";
import Header from "../../../components/Header";
import MHeader from "../../../components/MHeader";
import useDeviceType from "../../../Utils/useDeviceType";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import { Badge, Spin, Row, Col, Empty } from "antd";
import { isTrue } from "../../../Utils/filter";
import { useAtomValue } from "jotai";
import { studentEvaluationStatusAtom } from "../../main/store";
import { evaluationStatus, getEvaList } from "../../../API/evaluate";
import useRequest from "../../../Utils/useRequest";
import ListItem from "./Components/ListItem/index";

const Index = () => {
    const { isPC } = useDeviceType();
    const history = useHistory();
    const [query, setQuery] = useState<evaluationStatus>(
        evaluationStatus.NotEvaluated
    );
    const isEvaluation = useAtomValue(studentEvaluationStatusAtom);

    const [data, { loading }] = useRequest(() => getEvaList(query), {}, [
        query
    ]);

    return (
        <div className={Styles.root}>
            {isPC && <Header />}
            {!isPC && <MHeader title="我的" goBack={history.goBack} />}
            <div className={Styles.content}>
                <div className={Styles.tabs}>
                    <span
                        className={classNames(Styles.tabItem, {
                            [Styles.active]:
                                query === evaluationStatus.NotEvaluated
                        })}
                        onClick={() => setQuery(evaluationStatus.NotEvaluated)}>
                        <Badge dot={isTrue(isEvaluation)}>待评价</Badge>
                    </span>
                    <span
                        className={classNames(Styles.tabItem, {
                            [Styles.active]:
                                query === evaluationStatus.Evaluated
                        })}
                        onClick={() => setQuery(evaluationStatus.Evaluated)}>
                        已评价
                    </span>
                </div>
                <div className={Styles.con}>
                    <Spin spinning={loading}>
                        <Row type="flex" gutter={30}>
                            {data?.map(item => (
                                <Col
                                    span={isPC ? 8 : 24}
                                    key={item.evaluationId}>
                                    <ListItem item={item} />
                                </Col>
                            ))}
                        </Row>
                        {data?.length === 0 && (
                            <div className={Styles.emp}>
                                <Empty />
                            </div>
                        )}
                    </Spin>
                </div>
            </div>
        </div>
    );
};

export default Index;
